import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var PromoterBannersQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query promoterBannersQuery($bannerCategoryId: Int!) {\n    promoterBanners(bannerCategoryId: $bannerCategoryId) {\n      id\n      altText\n      url\n      image\n    }\n  }\n"])));
export default PromoterBannersQuery;